'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var groups = _ref.groups;
  return groups.map(function (tzg) {
    return {
      text: tzg.groupName,
      value: tzg.groupName,
      options: tzg.timezones.sort(function (x, y) {
        return parseInt(x.offset, 10) - parseInt(y.offset, 10);
      }).map(function (tz) {
        return {
          text: _I18n2.default.text('timezone_utils.utc_plus_minus', {
            offset: tz.offset,
            timezone: _I18n2.default.SafeString(tz.name)
          }),
          value: tz.identifier()
        };
      }).toJS()
    };
  }).sort(function (x, y) {
    var mainCountries = ['US', 'Europe', 'Canada'];
    for (var i in mainCountries) {
      if (x.text === mainCountries[i]) {
        return -1;
      }
      if (y.text === mainCountries[i]) {
        return 1;
      }
    }
  }).toArray();
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/utils/groupsToSelectOpts.js
// module id = 473
// module chunks = 0